import { createContext, useContext } from 'react';

export const CycleInfoContext = createContext({});
export const useCycleInfo = () => {
	const cycleInfo = useContext(CycleInfoContext);
	return cycleInfo;
};

export default CycleInfoContext.Provider;
